import { Dimensions, PixelRatio } from "react-native";

export const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get("window");
const baseWidth = 375; // iPhone 6 base width
const scale = SCREEN_WIDTH / baseWidth;

export const scaleDP = (size: number) =>
  Math.round(PixelRatio.roundToNearestPixel(size * scale));

export const isPortrait = SCREEN_HEIGHT >= SCREEN_WIDTH;
